export default __webpack_public_path__ + "static/media/edit.da17cea0.svg";